import React from 'react';

export const automationMenuTriggerRef: any = React.createRef();
